import { FC } from "react";

import {
  FieldErrorsImpl,
  UseFormHandleSubmit,
  UseFormRegister,
} from "react-hook-form";
import { Field } from "../../(components)/Field";
import { DelayButton } from "../../../(components)/DelayButton";

type Props = {
  handleSubmit: UseFormHandleSubmit<any>;
  onSubmit: (data: FormData) => void;
  errors: Partial<FieldErrorsImpl<any>>;
  register: UseFormRegister<any>;
  isSubmitting: boolean;
  submitCount: number;
  isValid: boolean;
  t: any;
  serverError: string;
};

const Form: FC<Props> = ({
  handleSubmit,
  onSubmit,
  errors,
  register,
  isSubmitting,
  submitCount,
  isValid,
  t,
  serverError,
}) => {
  return (
    <form className="space-y-4 mt-4" onSubmit={handleSubmit(onSubmit)}>
      <Field
        t={t}
        id="email"
        label="Email"
        type="email"
        placeholder="john@gmail.com"
        error={errors.email}
        {...register("email")}
      />

      <div>
        <DelayButton
          type="submit"
          text={t("recover_your_pass_form")}
          error={errors}
          delayText={t("resent_form")}
          afterDelayText={t("resent_form_again")}
          isLoading={isSubmitting}
          className="mt-10 w-full uppercase font-extrabold text-[14px] text-md-[16px] h-[48px]"
          submitCount={submitCount}
          isValid={isValid}
          serverError={serverError}
        />
      </div>
    </form>
  );
};

export { Form };
